var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$t("notification.tablePermissionChanged", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            tableName: _vm.$_.get(_vm.activity, "payload.tableName"),
          })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }